import React from "react";
import { get } from "lodash";
import { formatCurrency } from "utils";
import { Stack, Typography } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { ListingForm } from "components/shared/TableListing/types";
import { BasePrice } from "modules/equipment/types";
import { QuoteChargeListingEntity, QuoteChargeType } from "../../../../types";
import { DiscountType } from "@trnsact/trnsact-shared-types";

interface Props {
  field: keyof BasePrice;
}

export const EquipmentChargeColumnTotalCell = ({ field }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();
  const bodyFields = useWatch({ control, name: "bodyFields" });

  const calcs = (bodyFields ?? []).reduce(
    (total, row) => {
      const price = get(row, `${row.type === QuoteChargeType.Invoice ? "charge" : "equipment.price"}`, {}) as BasePrice;

      const calculateValue = (baseValue: number, priceData: BasePrice) => {
        const value = priceData[field] ?? 0;
        const typeField = `${field}Type` as keyof BasePrice;
        const type = priceData[typeField] as DiscountType;

        if (type === DiscountType.Percent && typeof value === "number") {
          return baseValue * (value / 100);
        }

        return +value;
      };

      const value = calculateValue(+price[field], price);

      const attachment = (row.equipment?.attachments ?? []).reduce((acc, attachment) => {
        if (attachment.price) {
          acc += calculateValue(+attachment.price[field], attachment.price);
        }
        return acc;
      }, 0);

      total.total += value + attachment;

      switch (row.type) {
        case QuoteChargeType.Invoice:
          total.invoice += value;
          break;
        case QuoteChargeType.Equipment: {
          total.equipment += value;
          total.attachments += attachment;
          break;
        }
      }

      return total;
    },
    { total: 0, invoice: 0, equipment: 0, attachments: 0 }
  );

  return (
    <Stack>
      <Typography>Total: {formatCurrency(calcs.total, true)}</Typography>
    </Stack>
  );
};
